export var ACTION;
(function (ACTION) {
    ACTION["GO_TO_INSTRUCTIONS_PAGE"] = "GO_TO_INSTRUCTIONS_PAGE";
    ACTION["POST_SELECTED_VALUE"] = "POST_SELECTED_VALUE";
    ACTION["CONTINUE_BUTTON_ACTION"] = "CONTINUE_BUTTON_ACTION";
})(ACTION || (ACTION = {}));
export var MutualAmountValueToBackend;
(function (MutualAmountValueToBackend) {
    MutualAmountValueToBackend["AMOUNT_10K_50K"] = "AMOUNT_10K_50K";
    MutualAmountValueToBackend["AMOUNT_50K_2L"] = "AMOUNT_50K_2L";
    MutualAmountValueToBackend["AMOUNT_2L_10L"] = "AMOUNT_2L_10L";
    MutualAmountValueToBackend["AMOUNT_ABOVE_10L"] = "AMOUNT_ABOVE_10L";
    MutualAmountValueToBackend["AMOUNT_0K"] = "AMOUNT_0K";
})(MutualAmountValueToBackend || (MutualAmountValueToBackend = {}));
export var MutualFundAmountSelected;
(function (MutualFundAmountSelected) {
    MutualFundAmountSelected["TEN_TO_FIFTY_K"] = "TEN_TO_FIFTY_K";
    MutualFundAmountSelected["FIFTY_TO_TWO_LAKH"] = "FIFTY_TO_TWO_LAKH";
    MutualFundAmountSelected["TWO_TO_TEN_LAKH"] = "TWO_TO_TEN_LAKH";
    MutualFundAmountSelected["MORE_THAN_TEN_LAKH"] = "MORE_THAN_TEN_LAKH";
    MutualFundAmountSelected["NO_MUTUAL_FUND"] = "NO_MUTUAL_FUND";
})(MutualFundAmountSelected || (MutualFundAmountSelected = {}));
